import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import mouseUtils from '../../components/utils/MouseUtils';
import appParameters from '../../components/utils/AppParameters';
import { showMainUniverse } from '../../actions/MenuActions';
import properties from '../../constants/Properties';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import platformDetection from '../utils/PlatformDetection';

const MainUniverseItemRendererContent = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeUniverse();
    },
    onClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeUniverse();
    },
    changeUniverse() {
        var currentMainUniverse = appParameters.currentMainUniverse;

        if (currentMainUniverse != this.props.item.universe) {
            masterUniverseUtils.changeMainUniverse(this.props.item.universe);
        } else {
            this.props.dispatch(showMainUniverse(false));
        }

        mouseUtils.setFocusSequence();
    },
    getTitle() {
        var universeItem  = this.props.item;

        if (!universeItem.translations)
            return universeItem.universe;
        else {
            var translation = universeItem.translations[masterUniverseUtils.language()];

            if (translation && translation.length > 0)
                return translation;
            else if (universeItem.translations['en_US'])
                return universeItem.translations['en_US'];
            else
                return universeItem.universe;
        }
    },
    getThumbnail() {
        return 'https://svg-cartoonist.creaza.com/thumbnails/universe_' + this.props.item.universe + '.png';
    },
    getColor() {
        var color = properties.BROWSER_SELECTED_COLOR;

        switch (this.props.item.universe) {
            case ('nature_science'): { // green
                color = '#52d856';
                break;
            }

            case ('world_history'): { //yellow
                color = '#f9c758';
                break;
            }

            case ('fiction'): { // red
                color = '#ec5871';
                break;
            }

            case ('generic'): { // blue
                color = '#58bced';
                break;
            }

            case ('alphabet_planet'): { // purple
                color = '#9252da';
                break;
            }
        }

        return color;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.refreshValue != newProps.refreshValue || this.props.listHeight != newProps.listHeight)
            return true;
        else
            return false;
    },
    render() {
        var textColor;
        var iconSrc;

        if (this.state.isOver == true) {
            textColor = '#dddddd';
            iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/selectedThemeHover.png';
        } else {
            textColor = 'white';
            iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/selectedTheme.png';
        }

        const aspectRatio = 1/3;
        const scrollWidth = 15;
        const hGap = 10;
        const bottomGap = 10;
        const buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
        var buttonHeight = buttonWidth * aspectRatio + bottomGap;
        var listHeight = this.props.listHeight;
        var itemsLength = this.props.itemsLength;
        var scrollHeight = buttonHeight * itemsLength;
        var extraItemHeight = 0;
        var realButtonHeight = buttonHeight;

        if (scrollHeight < listHeight) {
            var newButtonHeight = listHeight / itemsLength;
            extraItemHeight = newButtonHeight - buttonHeight;
            realButtonHeight = realButtonHeight + extraItemHeight;
        }

        const tabStyle = {
            position: 'absolute',
            width: buttonWidth,
            height: realButtonHeight,
            top: this.props.index * realButtonHeight,
            left: hGap,
            cursor: 'pointer',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            textAlign: 'left',
            borderStyle: 'none',
            background: 'none',
            display: 'flex'
        };

        var spanStyle = {
            position: 'relative',
            color: textColor,
            fontSize: 34,
            width: this.props.accordionWidth - 2 * hGap - scrollWidth - 5,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            top: '5%',
            textAlign: 'center',
            fontFamily: 'Arial',
            fontWeight: 'bold',
            textShadow: '0px 0px 10px black',
            cursor: 'pointer'
        };

        var imageStyle = {
            position: 'absolute',
            top: extraItemHeight,
            left: 0,
            width: buttonWidth,
            height: buttonHeight - bottomGap,
            cursor: 'pointer'
        };

        var iconVisible;

        if (this.props.item.universe == appParameters.currentMainUniverse)
            iconVisible = 'block';
        else
            iconVisible = 'none';

        var checkIconStyle = {
            position: 'absolute',
            top: 5,
            right: 5,
            display: iconVisible,
            width: 30,
            height: 30
        };

        if (platformDetection.isIOS()) {
            spanStyle.fontSize = 24;
            checkIconStyle.top = 3;
            checkIconStyle.right = 3;
            checkIconStyle.width = 25;
            checkIconStyle.height = 25;
        }

        var extraItemStyle = {
            position: 'absolute',
            top: 0,
            width: buttonWidth,
            height: extraItemHeight,
            background: this.getColor()
        };

        var universeTitle = this.getTitle();

        if (universeTitle.indexOf(' ') != -1) {
            universeTitle = universeTitle.replaceAll(' ', '\n');

            if (universeTitle.indexOf('The') != -1)
                universeTitle = universeTitle.replace('\n', ' ');

            spanStyle.whiteSpace = 'break-spaces';
            spanStyle.top = '3%';
        }

        var idValue;

        if (this.props.index == 0)
            idValue = 'firstUniverseElement';

        return (
            <button id={idValue} aria-label={universeTitle} style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchStart={this.onMouseDown} onClick={this.onClick} onTouchEnd={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                <div style={extraItemStyle}></div>
                <img alt={universeTitle} style={imageStyle} src={this.getThumbnail()}/>
                <span style={spanStyle}>{universeTitle}</span>
                <img alt='' aria-hidden='true' style={checkIconStyle} src={iconSrc}/>
            </button>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        accordionWidth
    };
}

export const MainUniverseItemRenderer = connect(mapStateToProps)(MainUniverseItemRendererContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/MainUniverseItemRenderer.js
 **/